/**
 * `subtasks` — a chevron plus the subitem count; never an editor (M2 §5.9, §6).
 * Expanding the nested table inline is M3.S1; the grid reserves the toggle and the indent.
 */
import { getColumnType, type SubtasksValue } from '@elizmonday/shared';
import { Icon, icons } from '@elizmonday/ui';
import { defineColumnUi } from '../types';
import { SubtasksSettingsDialog } from './SettingsDialog';

const shared = getColumnType('subtasks');

export const subtasksColumnUi = defineColumnUi<SubtasksValue, Record<string, unknown>>({
  type: 'subtasks',
  icon: 'columnSubtasks',
  gallery: { group: 'advanced', keywords: ['subitems', 'subtasks', 'children'] },
  /**
   * Never laid out (`gridColumn: false`), so this is only what a caller outside the grid would
   * reserve. 140 is the registry default (P-022).
   */
  defaultWidth: 140,
  /** P-023: monday has no `Subitems` grid column; the ⊕ is in the conversation cell. */
  gridColumn: false,
  align: 'center',
  groupable: false,

  Cell: ({ item }) => {
    const count = item.subitemIds.length;
    if (count === 0) return <span className="ez-cell__empty" aria-hidden="true" />;
    return (
      <span className="ez-subitems-cell" title={`${count} subitems`}>
        <Icon icon={icons.disclosureClosed} size={14} ignoreFocusStyle />
        {count}
      </span>
    );
  },

  SettingsDialog: SubtasksSettingsDialog,

  fromClipboard() {
    // Read-only: paste reports it as such `[B4§10 case 6]`.
    throw new Error('read-only');
  },
  toClipboard(value, settings) {
    return shared.toText(value, settings) ?? '';
  },
  bucketsOf() {
    return [];
  },
});
